import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-forms-help',
    templateUrl: './forms-help.component.html',
    styleUrls: ['./forms-help.component.css']
})
export class FormsHelpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
